import React, {Component} from 'react';
import Table from "../../components/Table/Table";
import {deepCopyObject, hasUserRight, showAxiosError} from "../../helper/helper";
import 'moment/locale/tr';
import {UserRightsEnum} from "../../helper/enums";
import {request} from "../../helper/APIUtils";
import {number} from "prop-types";
import {Col, FormText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import FormGroup from "react-bootstrap/FormGroup";
import NumberFormat from "react-number-format";
import Datetime from "react-datetime";
import moment from "moment/moment";
import DefaultModal from "../invoice/DefaultModal";

class SecondaryCopyTransferFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: [],
            loading: false,
            total: 0,
            page: 0,
            size: 5,
            selected: [],
            secondaryDetail: true,
        };

        this.fetchData = this.fetchData.bind(this);
        this.closeSecondaryCopyTransferFile = this.closeSecondaryCopyTransferFile.bind(this);
    }
    componentDidMount() {
        this.setState({selected: this.props.selected});
    }

    fetchData(){
        let self = this;
        let permitedData = [];
        let formdata = new FormData;
        formdata.append("transferId", this.props.selected.recordId.toString());
        let params = {
            url: "/secondaryCopyTransferFile/fetch",
            method: "post",
            data: formdata,
        }
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                response.data.map(data => {
                    data.status = data.status === "IN_QUEUE" ? "Sırada" : data.status;

                    if (data.name.includes("-Y-")) {
                        permitedData.push(data);
                    } else if (data.name.includes("-K-")) {
                        permitedData.push(data);
                    } else if (data.name.includes("-YB-")) {
                        if(data.name.includes("GIB")){
                            permitedData.push(data);
                        }
                    } else if (data.name.includes("-KB-")) {
                        if(data.name.includes("GIB")){
                            permitedData.push(data);
                        }
                    }
                });

                self.setState({content:permitedData,loading: false});
            }).catch(function (error) {
            showAxiosError(error);
        });

    }
    closeSecondaryCopyTransferFile(){
        this.props.toggle();
    }

    render() {
        const columns = [
            {
                Header: "Dosya ismi",
                accessor: "name",
                sortable: false,
            },

            {
                Header: "Durum",
                accessor: "status",
                sortable: false,
            },
            {
                Header: "Mesaj",
                accessor: "message",
                sortable: false,
            },
            {
                Header: "Tarih",
                accessor: "resultAt",
                sortable: false,
                Cell: row => (
                    <div>{moment(row.resultAt).isValid() ? moment(row.resultAt).format("DD-MM-YYYY HH:mm:ss") : ''}
                    </div>)
            },
        ]


        return(
            <Modal isOpen={this.props.modal} size='lg'>
                <ModalHeader toggle={this.closeSecondaryCopyTransferFile}>E-Defter İkincil Kopya Detay</ModalHeader>
                <ModalBody>
                    <div className="col-sm-12 row" style={{right: '-15px'}}>
                        <Col md={12}>
                            <FormGroup>
                                <Table columns={columns}
                                       content={this.state.content}
                                       paginationEnabled={false}
                                       fetchData={this.fetchData}
                                />
                            </FormGroup>
                        </Col>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

}

export default SecondaryCopyTransferFile;